/**
 * Data attributes bound to documentElement to infer CSS behaviour from scripts & event handlers.
 */
export const GLOBAL_ELEMENT_ATTRIBUTES = {
  scrolled: "data-scrolled",
  scrollDirection: "data-scroll-direction",
} as const;
